import type { ComponentProps } from "react";

export const VikingLogo = (props: ComponentProps<"svg">) => (
	<svg
		width="202"
		height="32"
		viewBox="0 0 202 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<title>Logo</title>
		<path
			d="M30.1999 0.655479L16.7066 16.275L10.8713 0.655479H0L13.813 31.8465L43.1175 0.655479H30.1999Z"
			fill="var(--svg-color, currentColor)"
		/>
		<path
			d="M148.921 0.623502L142.526 15.7634L122.446 0L109.145 31.287L119.824 31.255L126.283 15.9712L146.555 31.9425L159.84 0.623502H148.921ZM200.16 0.735412C193.557 0.527578 190.52 0.367706 180.847 0.783374C172.23 1.16707 162.382 5.80336 158.609 14.1167C157.011 17.6339 156.755 22.1903 158.897 25.5476C161.343 29.3685 165.979 30.7594 170.216 31.239C176.707 31.9904 183.853 31.7666 190.136 29.8002C192.438 29.0808 193.557 28.2974 193.557 28.2974L199.744 13.749H183.389L180.879 19.7282H188.234L186.555 23.6771C186.555 23.6771 183.325 24.8601 178.353 24.8601C173.381 24.8601 170.712 23.5971 169.56 22.6059C166.283 19.8082 168.058 15.2678 170.728 12.7578C174.149 9.5124 177.89 8.07355 182.51 7.65788C186.635 7.27419 195.875 7.54597 197.266 7.54597L200.16 0.735412Z"
			fill="var(--svg-color, currentColor)"
		/>
		<path
			d="M46.6027 0.655479L33.5571 31.319H44.2206L57.2182 0.655479H46.6027Z"
			fill="var(--svg-color, currentColor)"
		/>
		<path
			d="M100.751 0.607517H86.4908L66.6347 15.2838C69.6563 8.16947 72.9017 0.655479 72.9017 0.655479H62.2062L49.1926 31.319H59.8561C59.8561 31.319 62.6379 24.7162 65.7714 17.3142L78.4492 31.287L92.2302 31.255L78.2254 17.4261L100.751 0.607517ZM106.363 0.59153H116.994C116.994 0.59153 103.949 31.303 103.933 31.319H93.2854L106.363 0.59153Z"
			fill="var(--svg-color, currentColor)"
		/>
	</svg>
);
